<div class="d-flex flex-auto flex-column placeholder-container">
    <div class="d-flex flex-auto flex-row place-header">
      <div class="first-col">
      </div>
      <div class="second-col">
        <div class="main-line">Impressions</div>
      </div>
      <div class="third-col">
        <div class="main-line">Reach</div>
      </div>
      <div class="fourth-col">
        <div class="main-line">Impact</div>
      </div>
    </div>
    <div class="d-flex flex-auto flex-row placeholder-body-line"
         *ngFor="let item of postItems; let i = index; let lastRow = last"
         [ngClass]="{'even': i % 2 === 0, 'odd': i % 2 !== 0, 'customized-border-radius': lastRow}">
      <latest-post-item-placeholder class="d-flex flex-auto"></latest-post-item-placeholder>
    </div>
    <div class="d-flex flex-auto flex-row load-more">
      <div class="load-more-btn">Show more</div>
    </div>
  </div>
  <div class="message-popup" *ngIf="fallbackTitle && fallbackMessage">
    <div class="title">{{fallbackTitle}}</div>
    <div class="sub-title">{{fallbackMessage}}</div>
  </div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/latest-posts-placeholder/print-latest-posts-placeholder.component.html